import { translate } from "../../../locale";

export const EMAIL_TARGETS = [
  { id: "trabajo", label: translate("Trabajo") },
  { id: "principal", label: translate("Principal") },
  { id: "privado", label: translate("Privado") },
  { id: "sin_etiqueta", label: translate("Sin etiqueta") },
  { id: "otro", label: translate("Otro") },
  { id: "personalizado", label: translate("Personalizado") },
];

export const PHONE_TARGETS = [
  { id: "movil", label: translate("Movil") },
  { id: "fax", label: translate("Fax") },
  { id: "trabajo", label: translate("Trabajo") },
  { id: "principal", label: translate("Principal") },
  { id: "privado", label: translate("Privado") },
  { id: "sin_etiqueta", label: translate("Sin etiqueta") },
  { id: "otro", label: translate("Otro") },
  { id: "personalizado", label: translate("Personalizado") },
];
